import { AuditProgramScopeBean } from 'app/model/audit-program-scope-bean';
import { AuditorBenchAuditDetailDTO } from 'app/model/auditor-bench-audit-detail-dto';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonDTO } from 'app/model/common-dto';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuditeeDetailsService {
  //url = environment.SERVER_URL;
  url: string;

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }
  getAuditProgramScopeStatusNList(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(`${this.url}auditeeBench/auditeeDetail/list`, auditorBenchAuditDetailDTO);
  }

  getAuditProgramScopeDetail(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(
      `${this.url}auditeeBench/auditeeDetail/scopeDetail`,
      auditorBenchAuditDetailDTO
    );
  }

  auditProgramActionOnScope(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditeeBench/auditeeDetail/actionOnScope`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  auditProgramSubScopeCrudOperations(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(
      `${this.url}report/download-item-wise-report`,
      auditorBenchAuditDetailDTO
    );
  }

  getAuditeeAttachmentCountByScopeId(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(
      `${this.url}auditeeBench/auditeeDetail/auditeeAttachmentCountByScopeId`,
      auditorBenchAuditDetailDTO
    );
  }

  getUmbrellaGroupSettingForAttachment(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}auditeeBench/auditeeDetail/getUmbrellaGroupSetting`,
      commonDTO
    );
  }
}
